module.exports = __webpack_public_path__ + "static/media/setting.a958ed25.svg";